import { render, staticRenderFns } from "./WallpapersFormView.vue?vue&type=template&id=4da7cf16&scoped=true&"
import script from "./WallpapersFormView.vue?vue&type=script&lang=ts&"
export * from "./WallpapersFormView.vue?vue&type=script&lang=ts&"
import style0 from "./WallpapersFormView.vue?vue&type=style&index=0&id=4da7cf16&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4da7cf16",
  null
  
)

export default component.exports